import { render, staticRenderFns } from "./ManualBackup.vue?vue&type=template&id=a168b348&scoped=true&"
import script from "./ManualBackup.vue?vue&type=script&lang=js&"
export * from "./ManualBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a168b348",
  null
  
)

export default component.exports